import { useState, useEffect } from 'react';
import { initAnalytics, optOut } from '../lib/analytics';

const CONSENT_KEY = 'diwan_cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(() => !localStorage.getItem(CONSENT_KEY));

  useEffect(() => {
    // Analytics runs by default unless user has explicitly opted out
    if (localStorage.getItem(CONSENT_KEY) === 'declined') {
      optOut();
    } else {
      initAnalytics();
    }
  }, []);

  function accept() {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
  }

  function decline() {
    localStorage.setItem(CONSENT_KEY, 'declined');
    optOut();
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      background: 'var(--bg2)', borderTop: '1px solid var(--border)',
      padding: '12px 20px', display: 'flex', alignItems: 'center',
      justifyContent: 'space-between', gap: 12, zIndex: 9999, flexWrap: 'wrap',
    }}>
      <p style={{ margin: 0, fontSize: 13, color: 'var(--text2)', flex: 1 }}>
        We use analytics to improve Al-Diwan.{' '}
        <a href="/privacy" style={{ color: 'var(--gold)' }}>Privacy policy</a>
      </p>
      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <button onClick={decline} style={{
          background: 'none', border: '1px solid var(--border)',
          color: 'var(--text3)', borderRadius: 4, padding: '6px 14px',
          fontSize: 13, cursor: 'pointer',
        }}>Opt out</button>
        <button onClick={accept} style={{
          background: 'var(--gold)', border: 'none', color: 'var(--bg)',
          borderRadius: 4, padding: '6px 14px', fontSize: 13,
          cursor: 'pointer', fontWeight: 600,
        }}>OK</button>
      </div>
    </div>
  );
}
